var _path, _path2, _rect, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2352 26.437C58.4469 27.567 58.5132 29.4653 57.3833 30.6771L35.5979 54.0393C34.2419 55.4934 31.9639 55.5729 30.5098 54.217L22.4579 46.7085C21.2461 45.5785 21.1798 43.6802 22.3098 42.4684C23.4398 41.2567 25.3381 41.1904 26.5499 42.3203L32.8465 48.1921L52.9951 26.5851C54.1251 25.3734 56.0234 25.3071 57.2352 26.437Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2352 26.437C58.4469 27.567 58.5132 29.4653 57.3833 30.6771L35.5979 54.0393C34.2419 55.4934 31.9639 55.5729 30.5098 54.217L22.4579 46.7085C21.2461 45.5785 21.1798 43.6802 22.3098 42.4684C23.4398 41.2567 25.3381 41.1904 26.5499 42.3203L32.8465 48.1921L52.9951 26.5851C54.1251 25.3734 56.0234 25.3071 57.2352 26.437Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5753_3468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5753_3468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.38452 30.4614C-5.38452 12.7883 8.94236 -1.53857 26.6155 -1.53857H58.0001C75.6732 -1.53857 90.0001 12.7883 90.0001 30.4614V57.9999C90.0001 75.673 75.6732 89.9999 58.0001 89.9999H26.6155C8.94239 89.9999 -5.38452 75.673 -5.38452 57.9999V30.4614Z",
    fill: "url(#paint0_linear_5753_3468)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8399 25.9007C27.9171 24.8078 29.6717 24.7994 30.759 25.882L54.7912 49.8098C55.8785 50.8924 55.8868 52.656 54.8097 53.7489C53.7326 54.8418 51.978 54.8501 50.8906 53.7675L26.8585 29.8398C25.7711 28.7571 25.7628 26.9936 26.8399 25.9007Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8445 25.822C55.9233 26.9132 55.9178 28.6768 54.8322 29.7611L30.7247 53.8403C29.639 54.9247 27.8844 54.9192 26.8055 53.828C25.7267 52.7368 25.7322 50.9732 26.8178 49.8889L50.9253 25.8097C52.011 24.7253 53.7656 24.7308 54.8445 25.822Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5753_3468",
    x1: -3.09529,
    y1: 12.1922,
    x2: 85.2637,
    y2: 103.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD180"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.057ef75c172f0c432ad39bef016316c8.svg";
export { ForwardRef as ReactComponent };